var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfExclusionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.158 23.081a19.803 19.803 0 0 1-6.224.015c.079-.888.125-1.918.152-2.817-1.505-.904-2.866-2.42-3.847-4.164-1.244-.73-2.77-1.874-3.239-3.282-.833-2.5-1.667-4.166-1.667-4.166s1.758.562 3.344 1.45C9.856 5.59 12.455 2 17.999 2c5.543 0 8.145 3.59 8.324 8.117 1.586-.888 3.344-1.45 3.344-1.45s-.834 1.666-1.667 4.166c-.47 1.408-1.995 2.551-3.239 3.282-.973 1.73-2.319 3.235-3.81 4.142.044.898.11 1.932.207 2.824zm-8.303 1.638a49.733 49.733 0 0 1-3.305.955c-2.757.7-5.115 2.593-6.136 5.248L3 32h16.2a10.052 10.052 0 0 1 1.013-6.778 21.932 21.932 0 0 1-7.358-.503zM37 30a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-13-5 .5 2 3 3-3 3-.5 2 2-.5 3-3 3 3 2 .5-.5-2-3-3 3-3 .5-2-2 .5-3 3-3-3-2-.5z",
    fill: "#9A9CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfExclusionIcon);
export default __webpack_public_path__ + "static/media/selfExclusionIcon.ca4ebeb9.svg";
export { ForwardRef as ReactComponent };